function formatPhoneNumber(phoneNumber: string) {
  const regexp = /.{1,2}/g;
  const matches = phoneNumber.match(regexp);
  const displayedPhoneNumber = matches.join(' ');
  return displayedPhoneNumber;
}

export default formatPhoneNumber;
